module.exports = __webpack_public_path__ + "img/MatriculasAbertas-1300x350px.eec0356d.png";